

export class MachineInwordReq {
   id:number;
   machinedescription: string;
   barcode:string;
   transferDate: any;
  transferStartDate?: any;
  transferEndDate?: any;
}